import styled from 'styled-components';

export const Wrapper = styled.div`
  margin: 150px 0;

  @media (max-width: 576px) {
    margin: 50px 0;
  }
`;

export const InnerMain = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const LeftImage = styled.div`
  width: 630px;
  height: 600px;
  border-radius: 15px;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  @media (max-width: 576px) {
    display: none;
  }
`;

export const RightSide = styled.div`
  width: 600px;
  @media (max-width: 576px) {
    width: 100%;
  }
`;
